import { ThemeName } from 'es/app/theme/theme.types';

export const setThemeName = (payload: ThemeName) => ({
    type: 'SET_THEME_NAME' as const,
    payload,
});
